module.exports = __webpack_public_path__ + "static/media/distribuidor.e66dc2e7.svg";